//
import Service from '@/services/api/service'
import SlGroundSellerSaleModel from '@/models/Sale/SlGroundSellerSale'

/**
 * This class describes a sl ground seller sale.
 *
 * @class      SlGroundSellerSale (name)
 */
export default class SlGroundSellerSale extends Service {

  /**
   * The sl ground seller sale model
   */
  static model = SlGroundSellerSaleModel
}
